import { defineComponent as _defineComponent } from 'vue'
import { injectParentValidator } from '@/core/app.service';
import { useTranslations } from '@/core/translate.mixin';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemPOSCustomLineItemProperties',
  props: {
    disabled: { type: Boolean },
    lineItem: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({(e: 'change', value: { description: string, price: string}): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    disabled: boolean,
    lineItem: LineItemViewObject
}

const { t } = useTranslations();




const description = ref<string>(props.lineItem.comment);
const price = ref<string>(props.lineItem.unitPriceRaw.toString());
const priceRegex = /\d+/;

const $validator = injectParentValidator();

onMounted(() => {
    const dictionary = {
        custom: {
            [`custom-item-${props.lineItem.lineItemId}-description`]: {
                required: t('Pages.BasketPOS.CustomLineItemDescriptionRequiredErrorMessage'),
                max: t('Pages.BasketPOS.CustomLineItemDescriptionMaxLengthErrorMessage')
            },
            [`custom-item-${props.lineItem.lineItemId}-price`]: {
                regex: t('Pages.BasketPOS.CustomLineItemPriceInvalidErrorMessage')
            }
        }
    };
    $validator.localize('en', dictionary);
});

async function onChange() {
    const isValid = await $validator.validateAll();
    if (isValid) {
        emit('change', { description: description.value, price: price.value });
    }
}

return { __sfc: true,t, props, emit, description, price, priceRegex, $validator, onChange }
}

})